<template>
  <div>
    <form class="form cart-list-form">
      <div class="clear-btn-wrapper">
        <a type="button" :class="'small-btn --save ja is-6 clear-btn ' + cartButtonClass" v-on:click="clearItems"><i class="fas fa-eraser"></i> クリア</a>
      </div>
      <div class="add-cart-select-table-wrapper">
        <table class="font-text ja is-1 add-cart-select-table">
          <thead>
          <tr>
            <th>コードNo</th>
            <th class="option">
              <div class="select-group select-group-th">
                <p v-if="options.length > 1" :class="'group-title ' + (toggleFlag1 ? 'active' : '')" data-toggle="option1" v-on:click="toggle1"><span>選択肢</span></p>
                <p v-else>選択肢</p>
                <div :class="'bubble-th ' + (toggleFlag1 ? 'open' : '')" id="option1" v-if="options.length > 1 && toggleFlag1">
                  <p class="select_list" v-for="(option,index) in options" >
                    <input type="checkbox" :id="'op0-' + index" v-model="selectedItems1[index]"/>
                    <label class="font-text ja is-2" :for="'op0-' + index">{{option}}</label>
                  </p>
                </div>
              </div>
            </th>
            <th>単価（税抜）</th>
            <th >
              <div class="select-group select-group-th">
                <p v-if="units.length > 1" :class="'group-title ' + (toggleFlag2 ? 'active' : '')" data-toggle="option2" v-on:click="toggle2"><span>単位</span></p>
                <p v-else>単位</p>
                <div :class="'bubble-th ' + (toggleFlag2 ? 'open' : '')" id="option2" v-if="toggleFlag2">
                  <p class="select_list" v-for="(unit,index) in units">
                    <input type="checkbox" :id="'op1-' + index"  v-model="selectedItems2[index]">
                    <label class="font-text ja is-2" :for="'op1-' + index">{{unit}}</label>
                  </p>
                </div>
              </div>
            </th>
            <th>入り数</th>
            <th>
              <div class="select-group select-group-th">
                <p :class="'group-title' + (stockItemTexts.length < 2 ? '-none ' : ' ') + (toggleFlag3 ? 'active' : '')" data-toggle="option3" v-on:click="toggle3"><span>在庫</span></p>
                <div :class="'bubble-th ' + (toggleFlag3 ? 'open' : '')" id="option3" v-if="toggleFlag3">
                  <p class="select_list" v-for="(stock,index) in stockItems">
                    <input type="checkbox" :id="'op2-' + index" v-model="selectedItems3[index]">
                    <label class="font-text ja is-2" :for="'op2-' + index">{{ stockItemLabels[stock] || stock }}</label>
                  </p>
                </div>
              </div>
            </th>
            <th>注文数</th>
            <th>合計金額（税抜）</th>
          </tr>
          </thead>
          <tbody v-on:click="clearToggle">
          <tr v-for="item in items" :class="stockClass(item)">
            <th>{{item.code}}</th>
            <th>{{item.name}}</th>
            <th>@{{currency(item.price)}}円</th>
            <th>{{item.unit}}</th>
            <th>{{item.carton}}</th>
            <th>{{item.stock_info.text}}</th>
            <td v-if="item.stock_info.text !== '×'">
              <input class="input-amount" type="number" placeholder="0" :disabled="item.stock_info.status === 0"
                     v-model="productItems[item.index].amount"
                     v-on:keyup="changeAmount(item.index)" v-on:click="changeAmount(item.index)">
              <div v-if="!item.display_stock_zero && item.stock_info.text === '入荷待ち' && item.note.length > 0" style="margin-top:5px">
                {{ item.note }}
              </div>
            </td>
            <td v-else>
              {{ item.note }}
            </td>
            <td>
              <input class="calc-price" type="text" disabled placeholder="(自動計算)" v-model="productItems[item.index].sum"><span>円</span>
            </td>
          </tr>
          </tbody>
          <tfoot  v-on:click="clearToggle">
          <tr>
            <th colspan="6">合計</th>
            <td>
              <input class="calc-price" type="text" disabled placeholder="(自動計算)" v-model="itemAmount"><span>点</span>
            </td>
            <td>
              <input class="calc-price" type="text" disabled placeholder="(自動計算)" v-model="totalAmount"><span>円</span>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="spinner-container" v-if="ordering">
        <i class="fas fa-spinner fa-pulse"></i>
      </div>
      <p class="add-cart-btns">
        <a :class="'cart-btn square-btn --cart font-heading ja is-6 ' + cartButtonClass" id="modal-open1" v-on:click="addCart">
          <i class="far fa-shopping-cart p-right"></i>
          <span> カートに入れる</span>
        </a>
      </p>
      <p class="add-cart-btns">
        <a :class="'cart-btn square-btn --pay font-heading ja is-6 ' + cartButtonClass" id="modal-open2" v-on:click="purchase">
          <i class="far fa-shipping-fast p-right"></i>
          <span>すぐに注文確定する</span>
        </a>
      </p>
    </form>

    <div id="modal-box1" :class="toggleModal1Class">
      <div class="modal-inner">
        <div class="modal-close" id="modal-close1" v-on:click="continueShopping"><i class="far fa-times"></i></div>
        <p class="font-heading ja is-5" v-if="false">ありがとうございます。</p>
        <p class="font-text ja is-1" >商品をカートに入れました。</p>
        <table class="font-text ja is-2" v-if="false">
          <template v-for="item in cartItems.slice(0,1)">
          <tr>
            <th>コードNo</th>
            <td>{{item.code}}</td>
          </tr>
          <tr>
            <th>選択肢</th>
            <td>{{item.name}}</td>
          </tr>
          <tr>
            <th>単価</th>
            <td>@{{currency(item.price)}}円</td>
          </tr>
          <tr>
            <th>注文数</th>
            <td>@{{item.amount}}</td>
          </tr>
          </template>
          <template v-if="cartItems.length > 1">
            <tr>
              <td colspan="2" class="other-item-num">
                ほか {{cartItems.length - 1 }} 点
              </td>
            </tr>
          </template>
          <tr>
            <th>合計金額</th>
            <td>{{currency(cartItemTotal)}}円</td>
          </tr>
        </table>
        <p class="add-cart-btns"><a class="cart-btn square-btn font-heading ja is-6" href="#" v-on:click="continueShopping"><i class="far fa-shopping-cart p-right"></i><span>買い物を続ける</span></a></p>
        <p class="add-cart-btns"><a class="cart-btn square-btn --pay font-heading ja is-6" href="/cart" v-on:click="gotoOrder"><i class="far fa-shipping-fast p-right"></i><span>ご注文へ</span></a></p>
      </div>
    </div>

    <div id="modal-box3" :class="toggleModal3Class">
      <div class="modal-inner">
        <p class="icon"><i class="fa-3x fas fa-exclamation-triangle"></i> </p>
        <p class="font-text ja is-1" >在庫が不足しております。</p>
        <p class="font-text ja is-1" >出荷予定数は注文確定前にご確認頂けます。</p>
        <p class="add-cart-btns"><a class="cart-btn square-btn --pay font-heading ja is-6" href="#" v-on:click="closeModal3"><i class="far fa-check p-right"></i><span>OK</span></a></p>
      </div>
    </div>


    <div id="modal-box2" :class="toggleModal2Class">
      <div class="modal-inner">
        <div class="modal-close" id="modal-close2" v-on:click="continueShopping"><i class="far fa-times"></i></div>
        <p class="font-heading ja is-5">ありがとうございます。</p>
        <p class="font-text ja is-1">次の商品のご注文を承りました。</p>
        <table class="font-text ja is-2">
          <tr>
            <th>コードNo</th>
            <td>605-05009</td>
          </tr>
          <tr>
            <th>選択肢</th>
            <td>ブラック S</td>
          </tr>
          <tr>
            <th>単価</th>
            <td>@2,500円</td>
          </tr>
          <tr>
            <th>注文数</th>
            <td>10</td>
          </tr>
          <tr>
            <th>合計金額</th>
            <td>25,000円</td>
          </tr>
        </table><br>
        <table class="font-text ja is-2">
          <tr>
            <th>納入先</th>
            <td>リンエイ株式会社様<br>（岐阜県羽島郡岐南町八剣1-68）</td>
          </tr>
          <tr>
            <th>お支払い方法</th>
            <td>代引き決済</td>
          </tr>
        </table>
        <p class="add-cart-btns"><a class="cart-btn square-btn font-heading ja is-6" href="#" v-on:click="continueShopping"><i class="far fa-shopping-cart p-right"></i><span>買い物を続ける</span></a></p>
        <p class="add-cart-btns"><a class="cart-btn square-btn font-heading ja is-6" href="#" v-on:click="gotoOrderHistory"><i class="far fa-clipboard-list p-right"></i><span>注文履歴のご確認</span></a></p>
      </div>
    </div>

  </div>
</template>

<script>
import {gsap} from 'gsap'
import axios from 'axios'
import ScrollHint from 'scroll-hint'
export default {
  name: "order_list",
  props: ['id', 'formAuthenticityToken'],
  data: function() {
    return {
      productItems: [],
      cartItems: [],
      toggleFlag1: false,
      toggleFlag2: false,
      toggleFlag3: false,
      animatedIndex: 0,
      totalAmount: 0,
      selectedItems1: [],
      selectedItems2: [],
      selectedItems3: [],
      toggleModal1: false,
      toggleModal2: false,
      toggleModal3: false,
      nextOrder: false,
      ordering: false,
      stockItemLabels: {'○': '○：充分有り', '▲': '▲：残りわずか', '×': '×：ご購入不可', '入荷待ち': '入荷待ち', '廃番': '廃番', '取り寄せ': '取り寄せ', 'number': '数量分在庫有り'}
    }
  },
  async created() {
    const response = await axios.get ('/products/items/' + this.id + '.json')
    if (response.data.status === 200) {
      response.data.items.forEach((p,index) => {
        p.amount = 0
        p.sum = 0
        p.index = index
        this.productItems.push(p)
      })
    }
    this.selectedItems1 = Array(this.options.length).fill(true)
    this.selectedItems2 = Array(this.units.length).fill(true)
    this.selectedItems3 = Array(this.stockItems.length).fill(true)

    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN' : this.formAuthenticityToken
    }
  },
  mounted() {
    this.$nextTick(()=> {
      new ScrollHint('.add-cart-select-table-wrapper',
          {i18n: {
              scrollable: 'スクロールできます'
            }});
    })
  },
  computed: {
    stockItems() {
      return this.stockItemTexts.sort();
    },
    stockItemTexts() {
      const texts = []
      this.productItems.forEach((item) =>{
        if(/^([1-9]\d*|0)$/.test(item.stock_info.text)) {
          texts.push('number')
        }
        else {
          texts.push(item.stock_info.text)
        }
      })
      return Array.from(new Set(texts));
    },
    items() {
      let items = this.productItems
      items = items.filter((item)=> {
        return this.selectedItemLabel1.indexOf(item.name) >= 0
      })
      items = items.filter((item)=> {
        return this.selectedItemLabel2.indexOf(item.unit) >= 0
      })
      items = items.filter((item)=> {
        if(/^([1-9]\d*|0)$/.test(item.stock_info.text) && this.selectedItemLabel3.indexOf('number') >= 0) {
          return true
        }
        else {
          return this.selectedItemLabel3.indexOf(item.stock_info.text) >= 0
        }
      })
      return items

    },
    options () {
      return this.productItems
        .map((item)=> {return item.name })
        .filter((elem, index, self) => self.indexOf(elem) === index);
    },
    units () {
      return this.productItems
        .map((item)=> {return item.unit })
        .filter((elem, index, self) => self.indexOf(elem) === index);
    },
    total() {
      let value = 0;
      this.productItems.forEach((item) => {
        value += parseInt(item.amount) * parseInt(item.price) * parseInt(item.carton)
      });
      if (value == null || parseInt(value) < 0) {
        value = 0
      }
      return value
    },
    cartItemTotal() {
      let value = 0;
      this.cartItems.forEach((item) => {
        value += parseInt(item.amount) * parseInt(item.price) * parseInt(item.carton)
      });
      if (value == null || parseInt(value) < 0) {
        value = 0
      }
      return value
    },
    itemAmount() {
      let value = 0;
      this.productItems.forEach((item) => {
        if (!isNaN(item.amount) && parseInt(item.amount) >= 0) {
          value += parseInt(item.amount)
        }
      });
      if (isNaN(value)) {
        value = 0
      }
      return value
    },
    purchaseItems() {
      const items = []
      this.productItems.forEach((item) => {
        if (!isNaN(item.amount) && parseInt(item.amount) > 0) {
          items.push (
            {
              product_id: item.id,
              code: item.code,
              unit: item.unit,
              name: item.name,
              carton: item.carton,
              price: item.price,
              amount: item.amount,
              sub_total: parseInt(item.amount) * parseInt(item.price) * parseInt(item.carton)
            }
          )
        }
      });
      return items;
    },
    cartButtonClass() {
      return (this.itemAmount > 0 && !this.ordering) ? '' :  'disabled'
    },
    selectedItemLabel1() {
      const ret = []
      this.selectedItems1.forEach((item,index)=>{
        if (item) {
          ret.push(this.options[index])
        }
      })
      return ret;
    },
    selectedItemLabel2() {
      const ret = []
      this.selectedItems2.forEach((item,index)=>{
        if (item) {
          ret.push(this.units[index])
        }
      })
      return ret;
    },
    selectedItemLabel3() {
      const ret = []
      this.selectedItems3.forEach((item,index)=>{
        if (item) {
          ret.push(this.stockItems[index])
        }
      })
      return ret;
    },
    toggleModal1Class() {
      if (this.toggleModal1) {
        return 'modal active'
      }
      else {
        return 'modal'
      }
    },
    toggleModal2Class() {
      if (this.toggleModal2) {
        return 'modal active'
      }
      else {
        return 'modal'
      }
    },
    toggleModal3Class() {
      if (this.toggleModal3) {
        return 'modal active'
      }
      else {
        return 'modal'
      }
    }
  },
  methods: {
    purchase() {
      if (this.total > 0) {
        this.ordering = true
        axios.post (
          '/cart',
          {items: this.purchaseItems}
        ).then((response) => {
          if (response.data.status === 200) {
            this.ordering = false
            if(response.data.is_shortage_item) {
              this.nextOrder = true
              this.toggleModal3 = true
            }
            else {
              this.cartItems = JSON.parse(response.data.cart_items)
              document.location.href = "/orders/detail"
            }
          }
          this.ordering = false
        })
      }
    },
    closeModal3() {
      if(! this.nextOrder) {
        this.toggleModal3 = false
        this.toggleModal1 = true
      }
      else {
        document.location.href = "/orders/detail"
      }
    },
    addCart() {
      this.ordering = true
      if (this.total > 0) {
        axios.post (
          '/cart',
          {items: this.purchaseItems}
        ).then((response) => {
          if (response.data.status === 200) {
            this.cartItems = JSON.parse(response.data.cart_items)
            window.scrollTo(0, 0);
            if(response.data.is_shortage_item) {
              this.nextOrder = false
              this.toggleModal3 = true
            }
            else {
              this.toggleModal1 = true
            }
            this.ordering = false
          }
          else {
            this.ordering = false
            this.$dialog.alert(
                {
                  title: 'エラーが発生しました',
                  body: "<i class=\"fas fa-exclamation-circle\"></i> 商品の引当でエラーが発生しましたため、商品をカートに追加できませんでした"
                },
                {
                  okText: '<i class="fas fa-check"></i> 確認'
                }
            )
          }
        });
      }
    },
    clearItems() {
      this.productItems.forEach((item) => {
        item.amount = 0;
        item.sum = 0
      })
    },
    continueShopping() {
      location.reload();
    },
    gotoOrder() {
      location.reload();
    },
    gotoOrderHistory() {
      location.reload();
    },
    changeAmount(index) {
      this.animatedIndex = index
      if (this.productItems[index].amount === '') {
        this.productItems[index].amount = 0
        return false
      }
      this.productItems[index].amount = parseFloat(this.productItems[index].amount)
      if (this.productItems[index].amount < 0) {
        this.productItems[index].amount = 0
        return false
      }
      let  sum = this.productItems[index].price * this.productItems[index].amount * this.productItems[index].carton
      const obj = this.$data.productItems[index]
      obj.sum = obj.sum.toString().replace(/,/g,'')
      gsap.to(obj,.5,{
        sum: sum,
        ease: 'Power3.easeInOut',
        onUpdate: () => {
          obj.sum = this.currency(Math.floor(obj.sum))
        }
      });
    },
    stockClass(item) {
      if (item.stock_info.status === 1) {
        if (item.stock_info.text === "入荷待ち") {
          return 'stock-wait'
        }
        else {
          return 'stock-ok'
        }
      }
      else if (item.stock_info.status === 0) {
        return 'stock-ng';
      }
      else if (item.stock_info.status === 2 ) {
        return 'stock-s';
      }
    },
    clearToggle() {
      this.toggleFlag1 = false
      this.toggleFlag2 = false
      this.toggleFlag3 = false
    },
    currency(number) {
      return new Intl.NumberFormat('jp-JP').format(number)
    },
    toggle1() {
      this.toggleFlag1 = ! this.toggleFlag1
      this.toggleFlag2 = false
      this.toggleFlag3 = false
    },
    toggle2() {
      this.toggleFlag2 = ! this.toggleFlag2
      this.toggleFlag1 = false
      this.toggleFlag3 = false
    },
    toggle3() {
      if (this.stockItemTexts.length < 2) {
        return
      }
      this.toggleFlag3 = ! this.toggleFlag3
      this.toggleFlag1 = false
      this.toggleFlag2 = false
    }
  },
  watch: {
    total() {
      const obj = this.$data
      gsap.to(obj,.5,{
        totalAmount: this.total,
        ease: 'Power3.easeInOut',
        onUpdate: () => {
          if (!isNaN(obj.totalAmount)) {
            obj.totalAmount = this.currency(Math.floor(obj.totalAmount))
          }
          else {
            obj.totalAmount = 0
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-btn-wrapper {
  right: 10px;
  width: 100%;
  text-align: right;
}
.add-cart-select-table-wrapper {
}
.stock-ng {
  td {
    input, span {
      color: rgba(188, 165, 41, 0.1);;
    }
  }
}

#modal-box1 {
  .other-item-num {
    text-align: right;
  }
}

#modal-box3 {
  .icon {
    i {
      color: #bd465e;
    }
  }
}
</style>
